import { render, staticRenderFns } from "./AggiornaPswd.vue?vue&type=template&id=1fa6b84e"
import script from "./AggiornaPswd.vue?vue&type=script&lang=js"
export * from "./AggiornaPswd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports